"use client";
import { IBaseLabelValue } from "@/interfaces";
import { CustomButton, FlexBetween, FlexCenter, FlexCol } from "@/components";
import { cn } from "@/lib";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import { routes } from "@/routes";
import DownloadPdf from "../../pdfTemplates/downloadPdf";
import ResultContent from "../../resultContent";
import PdfTemplate from "@/components/pdfTemplates/pdfTemplate";
import { useRef } from "react";
import { IRawPurchasedNegativePointsInquiryResData } from "@/interfaces/inquiries/vehicle";

const NegativePointsInquiryDetails = ({
  data,
}: {
  data: IRawPurchasedNegativePointsInquiryResData;
}) => {
  const t = useTranslations("serviceResponseDetails");
  const router = useRouter();
  const negativePointsData = data.data;
  const inputContent: IBaseLabelValue[] = [
    {
      label: t("negativePointsInquiry.nationalCode"),
      value: negativePointsData.input.national_code,
    },
    {
      label: t("negativePointsInquiry.licenseNumber"),
      value: negativePointsData.input.license_number,
    },
  ];

  const resultContent = [
    {
      label: t("negativePointsInquiry.negPoint"),
      value:
        negativePointsData.data.body.negPoint === "0"
          ? "ندارد"
          : negativePointsData.data.body.negPoint,
    },
    {
      label: t("negativePointsInquiry.allowable"),
      value:
        negativePointsData.data.body.allowable === "1" ? "مجاز" : "مجاز نیست",
    },
  ];
  const pdfContentRef = useRef<HTMLDivElement>(null);
  return (
    <div className="shadow-main from-sky-bliss relative basis-[500px] rounded-2xl bg-linear-to-b to-transparent p-[2px] lg:basis-[640px]">
      <FlexCol className="items-stretch rounded-2xl bg-white p-8">
        <h2 className="mb-5 text-center font-bold lg:text-lg">
          {t("negativePointsInquiry.title")}
        </h2>
        <InputDataContent
          content={inputContent}
          className="le p-6 md:p-8"
          itemClassName="flex-col md:flex-row leading-9 md:leading-none"
        />
        <FlexBetween className="mb-3 items-center">
          <h2 className="text-center text-lg font-bold">
            {t("accountToIban.resultTitle")}
          </h2>
          <DownloadPdf
            htmlContentRef={pdfContentRef}
            useHtmlToPdf={true}
            id="negative-points-inquiry-download-pdf"
            fileName={`نمره منفی گواهینامه ${negativePointsData.input.national_code}`}
          />
        </FlexBetween>
        <ResultContent content={resultContent} />
        <FlexCenter className="flex flex-col justify-center md:flex-row md:gap-6">
          <DownloadPdf
            id="negative-points-inquiry-download-pdf"
            fileName={`نمره منفی گواهینامه ${negativePointsData.input.national_code}`}
            htmlContentRef={pdfContentRef}
            useHtmlToPdf={true}
            className="order-2 flex cursor-pointer items-center justify-center rounded-md border-none! bg-red-700 px-8 py-[6px] text-white transition-all hover:bg-red-800 md:order-1 lg:rounded-lg lg:py-[8px]"
            showIcon={false}
            labelClass="text-xs lg:text-sm xl:text-base font-medium"
          />
          <div className="order-1 mb-4 flex gap-4 md:order-2 md:m-0 xl:gap-6">
            <CustomButton
              id="details-negative-points-inquiry-back"
              className={cn("w-fit bg-gray-500")}
              onClick={() =>
                router.push(routes.main.INQUIRY_HISTORY.primaryPath)
              }
            >
              {t("companyInformationInquiry.backButton")}
            </CustomButton>
            <CustomButton
              id="details-negative-points-inquiry-new-request"
              onClick={() =>
                router.push(routes.services.Negative_Points.rewritePath)
              }
              className={cn("bg-primary-main mx-auto w-fit px-8! text-white")}
            >
              {t("newRequest")}
            </CustomButton>
          </div>
        </FlexCenter>
      </FlexCol>
      {/* This div will be used for PDF generation - DetailCreditCard style */}
      <div
        ref={pdfContentRef}
        style={{
          position: "fixed",
          left: "-9999px",
          top: "-9999px",
          width: "800px",
          fontFamily: "IRANYekan, sans-serif",
          margin: "2rem auto",
        }}
      >
        <PdfTemplate
          tableTitle={`نمره منفی گواهینامه ${negativePointsData.input.national_code}`}
          resultContent={resultContent}
          code={data.code}
          dateTime={data.created_at}
        />
      </div>
    </div>
  );
};

export default NegativePointsInquiryDetails;
